<template>
    <div>
        <div class="outmain ba_f">
            <div class="shuju_title mar_b20">
                <div class="shuju_title_text">
                    <span>{{ $t('set.storage.title') }}</span>
                </div>
            </div>
            <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="180px" class="demo-ruleForm">
                <div class="ba_f">
                    <div class="main-enclosure pad_tb_30">
                        <div class="t_l" style="margin-left: 100px;">
                            <el-radio-group v-model="type">
                                <el-radio
                                        v-for="item in radioOptions"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.value"
                                        border
                                        size="medium"
                                        @change="handleRadioChange"
                                >{{item.label}}
                                </el-radio>
                            </el-radio-group>
                        </div>
                        <div class="qny" v-show="type=='1'">
                            <div class="yb_margin pad_20 fon_12 color_38 ba_fe t_l">
                                {{ $t('set.storage.qiniuNotice') }}
                            </div>
                            <el-form-item :label="$t('set.storage.accesskey')"  :required="true">
                                <el-input v-model="ruleForm.qn_accesskey" autocomplete="off"
                                          :placeholder="$t('set.storage.accesskeyPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.accesskeyRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.secretkey')"  :required="true">
                                <el-input v-model="ruleForm.qn_secretkey" autocomplete="off"
                                          :placeholder="$t('set.storage.secretkeyPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.secretkeyRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.bucket')" :required="true">
                                <el-input v-model="ruleForm.qn_bucket"
                                          :placeholder="$t('set.storage.bucketPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.bucketRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.bucketRegion')" :required="true">
                                <el-select v-model="ruleForm.qn_endpoint" filterable :placeholder="$t('set.storage.selectRegion')"
                                           class="select">
                                    <el-option v-for="item in optionst1" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.url')" :required="true">
                                <el-input v-model="ruleForm.qn_url" :placeholder="$t('set.storage.urlPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.qiniuUrlRemark') }}</div>
                            </el-form-item>
                        </div>
                        <div class="aly" v-show="type=='2'">
                            <div class="tishi pad_20 fon_12 color_38 ba_fe t_l">
                                <p class="yb_margin">
                                    {{ $t('set.storage.aliyunNotice') }}<br/>
                                </p>
                            </div>
                            <el-form-item :label="$t('set.storage.accessKeyId')" :required="true">
                                <el-input v-model="ruleForm.aliyuncs_accesskey" autocomplete="off"
                                          :placeholder="$t('set.storage.accessKeyIdPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.accessKeyIdRemark') }}
                                </div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.accessKeySecret')" :required="true">
                                <el-input v-model="ruleForm.aliyuncs_secret" autocomplete="off"
                                          :placeholder="$t('set.storage.accessKeySecretPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.accessKeySecretRemark') }}
                                </div>
                            </el-form-item>

                            <el-form-item :label="$t('set.storage.endpointSelect')" :required="true">
                                <el-select v-model="ruleForm.aliyuncs_endpoint" filterable :placeholder="$t('set.storage.endpointSelectPh')"
                                           class="select" @change="ChangeEndpoint(ruleForm.aliyuncs_endpoint)">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                                <div class="remarks fon_12">{{ $t('set.storage.endpointRemark') }}
                                </div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.bucketSelect')" :required="true">
                                <el-select v-model="ruleForm.aliyuncs_bucket" filterable :placeholder="$t('set.storage.bucketSelectPh')"
                                           class="select">
                                    <el-option v-for="item in bucoptions" :key="item.label" :label="item.label"
                                               :value="item.label"></el-option>
                                </el-select>

                                <div class="remarks fon_12">{{ $t('set.storage.endpointRemark') }}
                                </div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.customUrl')" :required="true">
                                <el-input v-model="ruleForm.aliyuncs_url" :placeholder="$t('set.storage.customUrlPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.aliyunUrlRemark') }}
                                </div>
                            </el-form-item>
                        </div>
                        <div class="txy" v-show="type=='3'">
                            <div class="yb_margin pad_20 fon_12 color_38 ba_fe t_l">
                                {{ $t('set.storage.tencentNotice') }}
                            </div>
                            <el-form-item :label="$t('set.storage.appId')" :required="true">
                                <el-input v-model="ruleForm.xplqcloud_appid" autocomplete="off"
                                          :placeholder="$t('set.storage.appIdPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.appIdRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.secretId')" :required="true">
                                <el-input v-model="ruleForm.xplqcloud_secretid" autocomplete="off"
                                          :placeholder="$t('set.storage.secretIdPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.secretIdRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.secretKey')" :required="true">
                                <el-input v-model="ruleForm.xplqcloud_secretkey"
                                          :placeholder="$t('set.storage.secretKeyPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.secretKeyRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.bucket')" :required="true">
                                <el-input v-model="ruleForm.xplqcloud_bucket"
                                          :placeholder="$t('set.storage.tencentBucketPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.bucketRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.bucketRegion')" :required="true">
                                <el-select v-model="ruleForm.xplqcloud_endpoint" filterable :placeholder="$t('set.storage.selectRegion')"
                                           class="select">
                                    <el-option v-for="item in optionst" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                                <div class="remarks fon_12">{{ $t('set.storage.tencentRegionRemark') }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('set.storage.url')" :required="true">
                                <el-input v-model="ruleForm.xplqcloud_url" :placeholder="$t('set.storage.urlPh')"></el-input>
                                <div class="remarks fon_12">{{ $t('set.storage.tencentUrlRemark') }}
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="mar_t20 ba_f pad_20 t_c">
            <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
        </div>
    </div>
</template>
<script>
    import {getConfig,postConfig,getBucket} from "@/api/set";

    export default {
        components: {},
        created() {
            this.bus.$emit('loading', true);
            this.init();
        },
        computed: {
            radioOptions() {
                return [
                    { value: '0', label: this.$t('set.storage.localStorage') },
                    { value: '1', label: this.$t('set.storage.qiniu') },
                    { value: '2', label: this.$t('set.storage.aliyun') },
                    { value: '3', label: this.$t('set.storage.tencent') },
                ];
            },
            optionst1() {
                return [
                    { value: 'east_china', label: this.$t('set.storage.regionEastChina') },
                    { value: 'north_china', label: this.$t('set.storage.regionNorthChina') },
                    { value: 'south_china', label: this.$t('set.storage.regionSouthChina') },
                    { value: 'north_america', label: this.$t('set.storage.regionNorthAmerica') },
                ];
            },
            options() {
                return [
                    { value: 'oss-cn-hangzhou.aliyuncs.com', label: this.$t('set.storage.regionHangzhou') },
                    { value: 'oss-cn-shanghai.aliyuncs.com', label: this.$t('set.storage.regionShanghai') },
                    { value: 'oss-cn-qingdao.aliyuncs.com', label: this.$t('set.storage.regionQingdao') },
                    { value: 'oss-cn-beijing.aliyuncs.com', label: this.$t('set.storage.regionBeijing') },
                    { value: 'oss-cn-zhangjiakou.aliyuncs.com', label: this.$t('set.storage.regionZhangjiakou') },
                    { value: 'oss-cn-huhehaote.aliyuncs.com', label: this.$t('set.storage.regionHohhot') },
                    { value: 'oss-cn-shenzhen.aliyuncs.com', label: this.$t('set.storage.regionShenzhen') },
                    { value: 'oss-cn-hongkong.aliyuncs.com', label: this.$t('set.storage.regionHongKong') },
                    { value: 'oss-cn-chengdu.aliyuncs.com', label: this.$t('set.storage.regionChengdu') },
                ];
            },
            optionst() {
                return [
                    { value: 'bj', label: this.$t('set.storage.regionBeijingShort') },
                    { value: 'nj', label: this.$t('set.storage.regionNanjing') },
                    { value: 'sh', label: this.$t('set.storage.regionShanghaiShort') },
                    { value: 'gz', label: this.$t('set.storage.regionGuangzhou') },
                    { value: 'cd', label: this.$t('set.storage.regionChengduShort') },
                    { value: 'cq', label: this.$t('set.storage.regionChongqing') },
                    { value: 'hk', label: this.$t('set.storage.regionHongKong') },
                ];
            },
        },
        data() {
            return {
                cardLoading: true,
                ruleForm: {
                    id:'',
                    qn_accesskey: '',
                    qn_secretkey: '',
                    qn_bucket: '',
                    qn_endpoint: '',
                    qn_url: '',

                    aliyuncs_accesskey: '',
                    aliyuncs_secret: '',
                    aliyuncs_endpoint:'',
                    aliyuncs_bucket: '',
                    aliyuncs_customurl: '',

                    xplqcloud_appid: '',
                    xplqcloud_secretid: '',
                    xplqcloud_secretkey: '',
                    xplqcloud_bucket: '',
                    xplqcloud_endpoint: '',
                    xplqcloud_url: '',
                },
                bucoptions:[],
                type: '0',
                formInline:{
                    apply_image:'',
                    apply_name:'',
                    app_type_name:'',
                },
            };
        },
        methods: {
            async init() {
                const {data} = await getConfig({ident:'storage'});
                this.ruleForm = Object.assign(this.ruleForm, data);
                this.type = data.type?data.type:'0'
                this.bus.$emit('loading', false)
            },
            async handleRadioChange(){

             },
            async ChangeEndpoint(item) {
                var data ={}
                data = {
                    aliyuncs_accesskey:this.ruleForm.aliyuncs_accesskey,//公钥
                    aliyuncs_secret:this.ruleForm.aliyuncs_secret,//私钥
                    endpoint:item,
                }
                const res = await getBucket(data);
                console.log(res)
                if (res.code == 1) {
                    console.log(res.data)
                    this.bucoptions=res.data;
                }
            },
           async submitForm() {
                    this.ruleForm.ident = 'storage'
                    this.ruleForm.identName = this.$t('set.storage.title')
                    this.ruleForm.type = this.type
                    const {msg} = await postConfig(this.ruleForm);
                    this.$baseMessage(msg, "success");
                    this.init();
            },
        }
    }
</script>
